module.exports = __webpack_public_path__ + "img/BKL接线箱.9d20c6ba.jpg";